import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class CheckoutStateService {
  private currentStepSubject = new BehaviorSubject<number>(1); // 1 for Shopping Basket, 2 for login/guest, etc.
  public currentStep$ = this.currentStepSubject.asObservable();

  constructor(private authService: AuthService) {}

  setCurrentStep(step: number): void {
    // Debug log removed
    this.currentStepSubject.next(step);
    // Debug log removed
  }

  getCurrentStep(): number {
    return this.currentStepSubject.value;
  }

  // Method to handle navigation from cart to checkout
  proceedToCheckout(): void {
    // Check if user is already authenticated
    if (this.authService.isLoggedIn()) {
      this.setCurrentStep(3); // Skip login step, go to Customer Details (step 3)
    } else {
      this.setCurrentStep(2); // Go to Login/Guest step (step 2)
    }
  }

  // Method to handle going back to cart from checkout
  backToCart(): void {
    this.setCurrentStep(1); // Set to Shopping Basket step
  }
}
